// @flow
import * as React from 'react';
import styled from 'styled-components';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import FontIcon from 'material-ui/FontIcon';
import { FlexPlayerDemo } from '../../../styles';

const SDiv = styled.div`
  height: 60px;
  margin: auto;
  width: ${props => props.width}px;
`;

const StationLogo = styled(SDiv)`
  background: url("${props => (props.logo.preview || props.logo)}") no-repeat center center;
`;

const LogoHolder = styled(SDiv)`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  color: black;
`;

type Props = {
  colors: Object,
  data: Object,
}

export default function (props: Props) {
  return (
    <FlexPlayerDemo className="row" style={{ backgroundColor: props.colors.backgroundColor, height: '80px' }}>
      <div className="col-xs-5">
        { props.data.logo &&
          <StationLogo logo={props.data.logo} width={props.data.logoWidth} />
        }
        { !props.data.logo &&
          <LogoHolder width={props.data.logoWidth}>
            Logo
          </LogoHolder>
        }
      </div>
      <div className="col-xs-7">
        <FloatingActionButton backgroundColor={props.colors.iconBackgroundColor} mini iconStyle={{ fontSize: '24px', color: props.colors.iconTextColor }}>
          <FontIcon className="material-icons">play_arrow</FontIcon>
        </FloatingActionButton>
      </div>
    </FlexPlayerDemo>
  );
}




// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/components/playerConfigurationForm/statsRadioPlayer/demos/HeaderDemo.js